var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value"},[_c('MainMenu',{attrs:{"banner":_vm.navData.banner.value_banner,"mobileBanner":_vm.navData.banner.web_value_banner,"menu":_vm.menu}}),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }